<template>
  <!-- if no object/entity found fallback to error page -->
  <div v-if="err">
    <Error ref="error-page" />
  </div>
  <div
    v-else-if="indexedId"
    :key="'meta-' + indexedId"
    class="l-with-object-page-layout"
  >
    <!-- eslint-disable vue/no-unused-vars -->
    <router-view
      v-if="indexedId"
      v-slot="{ Component }"
      :key="indexedId"
      :indexed-id="indexedId"
    >
    </router-view>
    <ContentDisclaimerAndUse />
  </div>
</template>

<script>
import * as routerHelper from "@/helpers/Router";
import ContentDisclaimerAndUse from "@/components/atoms/contentDisclaimerAndUse/index.vue";
import Error from "@/components/pages/error/index.vue";

export default {
  name: "WithObjectPageLayout",
  components: {
    ContentDisclaimerAndUse,
    Error
  },
  data() {
    return {
      /**
       * The IndexedId for the record being loaded
       */
      indexedId: undefined,
      /**
       * The error from the router
       */
      err: undefined,
      /**
       * Any exceptions
       */
      exception: undefined
    };
  },
  computed: {
    /**
     * Gets the page title from the social sharing tag to show, this should only happen if we don't have an ID,
     * which should only be on page load
     */
    title() {
      // this could be made better if we embedded the slug or id in the page and only show it if we have that info
      let title = document.querySelector('meta[name="og:title"]');
      if (title == undefined) {
        return "";
      }
      return title.content;
    }
  },
  watch: {
    "$route.params.slug": "getIndexedIdFromRoute",
    "$route.name": "getIndexedIdFromRoute"
  },
  created() {
    this.getIndexedIdFromRoute();
  },
  methods: {
    /**
     * Requests the Indexed ID from the ID Manager
     */
    getIndexedIdFromRoute() {
      // reset the indexedId
      this.indexedId = undefined;
      routerHelper
        .getIndexedIdFromRoute(this.$route, undefined)
        .then((result) => {
          this.indexedId = result.indexedId;
          this.err = result.status;
          this.exception = result.exception;
        });
    }
  }
};
</script>

<style lang="scss">
.l-with-object-page-layout {
  .v-with-object-page-layout__status::before {
    content: "Loading... ";
  }
  .iiif-logo {
    max-height: 1.2rem;
    margin-bottom: 0.2rem;
  }
}
</style>
